import { render, staticRenderFns } from "./ContactFieldPhone.vue?vue&type=template&id=542a154b&"
import script from "./ContactFieldPhone.vue?vue&type=script&lang=js&"
export * from "./ContactFieldPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports